import CargoSpecs from "./cargo-specs.container";

export default CargoSpecs;
